/*
 * Inspinia js helpers:
 *
 * correctHeight() - fix the height of main wrapper
 * detectBody() - detect windows size
 * smoothlyMenu() - add smooth fade in/out on navigation show/hide
 *
 */

declare var jQuery: any;

export function correctHeight() {

  let pageWrapper = jQuery('#page-wrapper');
  let navbarHeight = jQuery('nav.navbar-default').height();
  let wrapperHeight = pageWrapper.height();

  if (navbarHeight > wrapperHeight) {
	pageWrapper.css('min-height', navbarHeight + 'px');
  }

  if (navbarHeight <= wrapperHeight) {
	if (navbarHeight < jQuery(window).height()) {
		pageWrapper.css('min-height', jQuery(window).height() + 'px');
	} else {
		pageWrapper.css('min-height', navbarHeight + 'px');
	}
  }

  if (jQuery('body').hasClass('fixed-nav')) {
	if (navbarHeight > wrapperHeight) {
		pageWrapper.css('min-height', navbarHeight + 'px');
	} else {
		pageWrapper.css('min-height', jQuery(window).height() - 60 + 'px');
	}
  }
}

export function detectBody() {
  if (jQuery(document).width() < 769) {
	jQuery('body').addClass('body-small')
  } else {
	jQuery('body').removeClass('body-small')
  }
}

export function smoothlyMenu() {
  if (!jQuery('body').hasClass('mini-navbar') || jQuery('body').hasClass('body-small')) {
	// Hide menu in order to smoothly turn on when maximize menu
  jQuery('#side-menu').hide();
  jQuery('#side-menu').css('overflow-y', 'auto');
	jQuery('#side-menu-account').hide();
	// For smoothly turn on menu
	setTimeout(
		function () {
		jQuery('#side-menu').fadeIn(400);
		jQuery('#side-menu-account').fadeIn(400);
		}, 200
	);
  } else if (jQuery('body').hasClass('fixed-sidebar')) {
	jQuery('#side-menu').hide();
  jQuery('#side-menu').css('overflow-y', 'auto');
	jQuery('#side-menu-account').hide();
	setTimeout(
		function () {
		jQuery('#side-menu').fadeIn(400);
		jQuery('#side-menu-account').fadeIn(400);
		}, 100);
  } else {
	// Remove all inline style from jquery fadeIn function to reset menu state
	jQuery('#side-menu').removeAttr('style');
	jQuery('#side-menu-account').removeAttr('style');
  }
}
